import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, shareReplay } from 'rxjs/operators';

import { StrapiService } from './strapi.service';
import { Navigation } from '../models/navigation.models';

/**
 * Exposes the Strapi `/api/navigation` payload as both an Observable
 * (`navigation$`) and a Signal (`navigation`). Uses the same `shareReplay`
 * pattern as `GlobalService` so the HTTP call fires once per app boot and
 * every subscriber gets the cached result.
 */
@Injectable({ providedIn: 'root' })
export class NavigationService {
  private readonly strapi = inject(StrapiService);

  readonly navigation$ = this.strapi.findNavigation().pipe(
    map((r) => r.data),
    shareReplay({ bufferSize: 1, refCount: false }),
  );

  readonly navigation = toSignal<Navigation | null>(this.navigation$, { initialValue: null });
}
